import { Cell, Row, flexRender } from "@tanstack/react-table";
import classNames from "classnames";

import { useTableContext } from "../context";
import { GRID_CELL_FOCUS_CLASSES } from "../grid-classes";
import CellControl from "./edit-controls";

export default function TableRowCell<T>({
  row,
  cell,
}: {
  row: Row<T>;
  cell: Cell<T, unknown>;
}) {
  const { table, editMode, columnWidths } = useTableContext();
  const editableColumns = table?.options?.meta?.editableColumns ?? {};

  const columnId = cell.column?.id;
  const editableOptions = editableColumns[columnId] ?? undefined;
  const isEditable = !!editableOptions && editMode;
  const width = columnWidths[columnId];

  return (
    <td
      key={cell.id}
      className={classNames(
        "px-4 truncate [&_a]:relative [&_a]:hit-target [&_a]:before:left-0 [&_a]:before:min-h-[48px] [&_a]:before:[transform:translateY(-50%)] [&_button]:relative [&_button]:hit-target",
        isEditable ? "py-0" : "py-2",
        GRID_CELL_FOCUS_CLASSES,
      )}
      style={{ width }}
      data-grid-edit={isEditable ? "" : undefined}
    >
      {isEditable ? (
        <CellControl cell={cell} row={row} options={editableOptions} />
      ) : (
        flexRender(cell.column.columnDef.cell, cell.getContext())
      )}
    </td>
  );
}
